import { AcademiesNavItemType, AggregatorNavItemType, AIAssistantNavItemType, AIElevateNavItemType, AILearningNavItemType, BadgeNavItemType, GoogleCertificateNavItemType, LearningTypeNavItemType, RolePlayNavItemType } from './events';
import { AISubcategoryNavItemType } from './utils/constants';
export const BROWSE_TYPE = {
  CATEGORY: 'category',
  SUBCATEGORY: 'subcategory',
  TOPIC: 'course_label'
};
export const CERTIFICATION_TYPE = {
  CERTIFICATION_PREPARATION: 'certification_preparation',
  CERTIFICATION_SUBJECT_AGGREGATOR: 'certification_subject_aggregator',
  CERTIFICATION_ISSUER_AGGREGATOR: 'certification_issuer_aggregator',
  CERTIFICATION_TOPIC: 'certification_topic'
};
export const ACADEMIES_TYPE = {
  CAREER_ACADEMY: AcademiesNavItemType.CAREER_ACADEMY,
  ALL_ACADEMIES: AcademiesNavItemType.ALL_ACADEMIES
};
export const BROWSE_LEARNING_TYPES = gettext => ({
  LABS: {
    id: 0,
    type: LearningTypeNavItemType.LABS,
    title: gettext('Labs'),
    absolute_url: '/labs/listing/'
  },
  UDEMY_PRO_PATHS: {
    id: 1,
    type: LearningTypeNavItemType.UDEMY_PRO_PATHS,
    title: gettext('Udemy paths'),
    absolute_url: '/learning-paths/pro/'
  }
});
export const BADGING_NAV = (gettext, isExploreByGoalHeadingTitleShown) => ({
  CERTIFICATIONS: {
    id: 0,
    type: BadgeNavItemType.CERTIFICATIONS,
    title: isExploreByGoalHeadingTitleShown ? gettext('Prepare for a certification') : gettext('Certification preparation'),
    absolute_url: '/open-badges/'
  },
  ORGANIZATION_BADGES: {
    id: 1,
    type: BadgeNavItemType.ORGANIZATION_BADGES,
    title: gettext('Company badges'),
    absolute_url: '/organization-badges/'
  },
  ASSESSMENTS_NAV: {
    id: 2,
    type: BadgeNavItemType.ASSESSMENTS,
    title: gettext('Measure skills with Assessments'),
    absolute_url: '/skills-assessment/'
  }
});
export const AGGREGATOR_NAV = (gettext, isExploreByGoalHeadingTitleShown) => ({
  AGGREGATORS: {
    id: 0,
    type: AggregatorNavItemType.CERTIFICATION_PREPARATION,
    title: isExploreByGoalHeadingTitleShown ? gettext('Prepare for a certification') : gettext('Certification preparation'),
    absolute_url: '/browse/certification/'
  }
});
export const ACADEMIES_NAV = gettext => ({
  ALL_ACADEMIES: {
    id: -1,
    type: AcademiesNavItemType.ALL_ACADEMIES,
    title: gettext('Launch a new career'),
    absolute_url: '/career-accelerators/'
  }
});
export const AI_ASSISTANT_NAV = gettext => ({
  AI_ASSISTANT: {
    id: 2,
    type: AIAssistantNavItemType.DISCOVERY,
    title: gettext('AI Assistant'),
    absolute_url: '/ai-assistant/'
  }
});
export const AI_ELEVATE_NAV = (gettext, isTPUser = false) => ({
  AI_COURSES: {
    id: 4,
    type: AIElevateNavItemType.AI_COURSES,
    title: gettext('AI Courses'),
    absolute_url: isTPUser ? '/courses/ufb-generative-ai/' : '/learn-ai/'
  }
});
export const AI_LEARNING_NAV = gettext => ({
  AI_LEARNING: {
    id: 3,
    type: AILearningNavItemType.LEARN_AI,
    title: gettext('Learn AI'),
    absolute_url: 'none',
    children: [{
      id: 1,
      type: BROWSE_TYPE.SUBCATEGORY,
      title: gettext('AI Fundamentals'),
      slug: AISubcategoryNavItemType.AI_FUNDAMENTALS,
      absolute_url: 'none'
    }, {
      id: 2,
      type: BROWSE_TYPE.SUBCATEGORY,
      title: gettext('AI For Professionals'),
      slug: AISubcategoryNavItemType.AI_FOR_PROFESSIONALS,
      absolute_url: 'none'
    }, {
      id: 3,
      type: BROWSE_TYPE.SUBCATEGORY,
      title: gettext('AI For Developers'),
      slug: AISubcategoryNavItemType.AI_FOR_DEVELOPERS,
      absolute_url: 'none'
    }, {
      id: 4,
      type: BROWSE_TYPE.SUBCATEGORY,
      title: gettext('AI For Creatives'),
      slug: AISubcategoryNavItemType.AI_FOR_CREATIVES,
      absolute_url: 'none'
    }]
  }
});
export const ROLE_PLAY_NAV = gettext => ({
  ROLE_PLAY: {
    id: -1,
    type: RolePlayNavItemType.ROLE_PLAY,
    title: gettext('Practice with Role Play'),
    absolute_url: '/ai-roleplay/'
  }
});
export const GOOGLE_CERTIFICATE_NAV = gettext => ({
  GOOGLE_CERTIFICATES: {
    id: -2,
    type: GoogleCertificateNavItemType.GOOGLE_CERTIFICATES,
    title: gettext('Learn AI with Google'),
    // L1 nav item links directly to the Google AI learning page.
    // This URL is also used as the event ID in BrowseNavigationItemSelected tracking
    // (see googleCertificateNavItemType branch in browse-nav.mobx-store.ts).
    absolute_url: '/partner/google/learn-ai/',
    // Children will be populated dynamically from gwgAcceleratorsNav
    children: []
  }
});
//# sourceMappingURL=browse-constants.js.map